export function resolveBreakpoint(breakpoints, width) {
  if (!Array.isArray(breakpoints) || width == null || !Number.isFinite(width)) return null;
  for (const bp of breakpoints) {
    if (!bp?.name) continue;
    const min = bp.min_width ?? Number.NEGATIVE_INFINITY;
    const max = bp.max_width ?? Number.POSITIVE_INFINITY;
    if (width >= min && width <= max) return bp.name;
  }
  return null;
}

/** Viewport breakpoint, or first named breakpoint where the preview root is visible (e.g. sidebar · wide only). */
export function resolvePreviewBreakpoint(node, breakpoints, viewportWidth) {
  const preferred = resolveBreakpoint(breakpoints, viewportWidth);
  if (!node || typeof node !== "object") return preferred;
  if (resolveNodeForBreakpoint(node, preferred).visible) return preferred;

  const names = Array.isArray(breakpoints)
    ? [...breakpoints]
      .filter((bp) => bp?.name)
      .sort((a, b) => (b.min_width ?? 0) - (a.min_width ?? 0))
      .map((bp) => bp.name)
    : ["wide", "regular", "compact", "mobile"];

  for (const name of names) {
    if (resolveNodeForBreakpoint(node, name).visible) return name;
  }
  return preferred;
}

export function resolveNodeForBreakpoint(node, breakpointName) {
  if (!node || typeof node !== "object") return { node, visible: true };
  const layout = node.layout && typeof node.layout === "object" ? node.layout : {};
  const patch = breakpointName ? layout.breakpoints?.[breakpointName] : null;
  const visibility = node.visibility ?? node.appearance?.visibility;
  if (!patch) {
    return { node, visible: visibility !== "gone" };
  }

  const resolved = { ...node, layout: { ...layout } };
  const layoutPatch = { ...patch };
  if (layoutPatch.direction) {
    resolved.direction = { ...(node.direction || {}), ...layoutPatch.direction };
    delete layoutPatch.direction;
  }
  resolved.layout = { ...layout, ...layoutPatch };
  delete resolved.layout.breakpoints;
  const resolvedVisibility = patch.visibility ?? visibility;
  if (patch.visibility != null) resolved.visibility = patch.visibility;
  return { node: resolved, visible: resolvedVisibility !== "gone" };
}
